import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LANDING_ROUTE, ORGANISER_DASHBOARD} from "src/app/app-routing.module";
import {RaceSettings} from "@model";
import {RaceSettingsService} from "@services";

export const RaceSettingsListResolver: ResolveFn<Observable<RaceSettings[] | null> |
  Promise<RaceSettings[] | null> | RaceSettings[] | null> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceSettingsService: RaceSettingsService = inject(RaceSettingsService),
   router: Router = inject(Router)): Observable<RaceSettings[] | null> |
    Promise<RaceSettings[] | null> | RaceSettings[] | null => {
    let eventId = route.queryParams["eventId"];
    if (!eventId) {
      router.navigate(!!route.data["protected"] ? [ORGANISER_DASHBOARD] : [LANDING_ROUTE]);
      return EMPTY;
    } else {
      return raceSettingsService.fetchRaceSettingsByEventId(
        +eventId, true)
        .pipe(
          take(1),
          mergeMap((res: RaceSettings[] | null) => {
            return of(res);
          })
        );
    }
  }
